module.exports = global["jQuery"] = require("-!/builds/FQur4r4k/0/elements/elements-ui/node_modules/expose-loader/index.js?$q!./jquery.js");


//////////////////
// WEBPACK FOOTER
// ./cloud/lib/jquery.js
// module id = 1
// module chunks = 49